<template lang="pug">
AssetChangelogTable(:changelogs="changelogs")

.flex.flex-row.justify-center.mt-4.w-full
  el-pagination(
    v-model:current-page="paging.page",
    :hide-on-single-page="true",
    background,
    layout="prev, pager, next",
    :page-count="totalPages"
  )
</template>

<script setup lang="ts">
import { onMounted, computed } from "vue";
import { useChangelogsStore } from "../../../stores/changelogs";
import { ref, watch } from "vue";
import { formatDateTime } from "../../../util/formatting";
import type { TwinChangelog } from "../../../services/twinData";
import { useMq } from "vue3-mq";
import type { ChangeObj } from "../../../services/twinData";
import { stateLoading } from "../../../models/state";
import { useI18n } from "vue-i18n";

import AssetChangelogTable from "./TwinChangelogTable.vue";

const mq = useMq();

const { t } = useI18n();

const props = defineProps<{
  twinId: string;
}>();

const changelogsStore = useChangelogsStore();

const totalPages = computed(
  () => changelogsStore.changelogsState.page?.pagesTotal ?? 0,
);

const changelogs = computed(() => {
  return changelogsStore.changelogsState.result;
});

const loading = computed(() => changelogsStore.changelogsState.loading);

const paging = ref({
  page: 1,
  pageSize: 10,
});

onMounted(() => {
  loadData();
});

watch(
  () => paging.value.page,
  () => {
    loadData();
  },
);

function loadData() {
  changelogsStore.loadChangelogs(paging.value, { twins: [props.twinId] });
}
</script>

<style>
.new-properties-grid {
  display: grid;
  grid-template-columns: min-content min-content min-content;
  row-gap: 1rem;
  column-gap: 1rem;
  white-space: nowrap;
}

@media only screen and (max-width: 768px) {
  .new-properties-grid {
    grid-template-columns: 1fr;
    row-gap: 0.5rem;
    white-space: normal;
  }
}
</style>
